import { render, staticRenderFns } from "./secondaryMarketing.vue?vue&type=template&id=526b9676&scoped=true"
import script from "./secondaryMarketing.vue?vue&type=script&lang=js"
export * from "./secondaryMarketing.vue?vue&type=script&lang=js"
import style0 from "./secondaryMarketing.vue?vue&type=style&index=0&id=526b9676&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b9676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526b9676')) {
      api.createRecord('526b9676', component.options)
    } else {
      api.reload('526b9676', component.options)
    }
    module.hot.accept("./secondaryMarketing.vue?vue&type=template&id=526b9676&scoped=true", function () {
      api.rerender('526b9676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/secondaryMarketingPosition/components/secondaryMarketing.vue"
export default component.exports